import { render, staticRenderFns } from "./UiDropdown.vue?vue&type=template&id=1f6c3d26&lang=pug&"
import script from "./UiDropdown.vue?vue&type=script&lang=ts&"
export * from "./UiDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports